<template>
  <div>
    <el-dialog
      :title="indexId?'编辑店铺':'添加店铺'"
      :visible.sync="show"
      class="top-draft-dialog"
      :before-close="handleClose">
      <div class="card">
        
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label>门店名称</label>
              <input
                v-model="item.name"
                type="text"
                class="form-control"
                placeholder="请输入门店名称"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label>门店地址</label>
              <input
                v-model="item.address"
                type="text"
                class="form-control"
                placeholder="请输入门店地址"
                @input="getAddressInfo"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <label>具体位置</label>
              <div id="map-container"></div>
            </div>
          </div>
        </div>

        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button @click="handleClose()" class="btn-sm btn btn-outline-dark" type="button">取消</button>
              <button @click="submitCreate()" class="btn-sm btn btn-primary" type="button">确定</button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import Vue from "vue";
import Swal from "sweetalert2";
import shop from '../../../server/api/shop'
import pagination from "@/components/pagination/pagination.vue";
var searchService,geocoder,map,markersArray = [];
export default {
  components: {pagination},

  data() {
    return {
      show: false,
      item: {},
      indexId: '',
      geocoder: null,
      markers: null
    };
  },

  mounted() {},

  methods: {

    showModel(indexId){
      let that = this
      if(indexId){
        that.indexId = indexId
      } else {
        that.indexId = ''
        that.item = {}
      }
      setTimeout(function(argument) {
        that.initMap()
        if(indexId){
          that.fetch()
        }
      }, 500)
      this.show = true
    },

    handleClose(){
      this.show = false
    },

    initMap() {
      let that = this;
      //定义地图中心点坐标
      var center = new qq.maps.LatLng(0,0)
      var map = new qq.maps.Map(document.getElementById("map-container"), {
        center: center,
        zoom: 16
      });
      // var latlngBounds = new qq.maps.LatLngBounds();
      // qq.maps.event.addListener(map, "click", function(event) {
      //   that.item.longitude = event.latLng.getLng(); // 经度
      //   that.item.latitude = event.latLng.getLat(); // 纬度
      //   if (markersArray) {
      //     for (let i in markersArray) {
      //       markersArray[i].setMap(null);
      //     }
      //   }
      //   var marker = new qq.maps.Marker({
      //     map: map,
      //     position: event.latLng
      //   });
      //   markersArray.push(marker);
      // });
      //调用地址解析类
      this.geocoder = new qq.maps.Geocoder({
        complete : function(result){
          console.log(result.detail.location)         
          that.item.longitude = result.detail.location.lng;
          that.item.latitude = result.detail.location.lat;
          map.setCenter(result.detail.location);
          var marker = new qq.maps.Marker({
            map: map,
            position: result.detail.location
          });
          console.log('开始',markersArray)
          markersArray.push(marker);
          console.log('结束',markersArray)
        }
      });
    },

    getAddressInfo(){
      if(this.geocoder){
        if (markersArray) {
          for (var i in markersArray) {
            markersArray[i].setMap(null);
          }
          markersArray.length = 0;
        }
        this.geocoder.getLocation(this.item.address);
      }
    },

    //获取列表数据
    fetch() {
      let params = {
        id: this.indexId
      }
      shop.detail(params).then(resp => {
        if (resp.code == 0) {
          if(resp.data){
            this.item = resp.data
            if(resp.data.address){
              this.getAddressInfo()
            }
          }
        }
      })
    },

    submitCreate(){
      let params = JSON.parse(JSON.stringify(this.item)); //copy对象
      if(!params.name){
        Vue.swal("请输入门店名称");
        return
      }
      if(!params.address){
        Vue.swal("请输入门店地址");
        return
      }
      if(!params.longitude){
        Vue.swal("未获取到经纬度");
        return
      }
      if(this.indexId){
        shop.modify(params).then(resp => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "修改成功！",
              showConfirmButton: false,
              timer: 1000
            });
            this.handleClose()
            this.$emit('getList')
          }
        })
      } else {
        shop.create(params).then(resp => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "添加成功！",
              showConfirmButton: false,
              timer: 1000
            });
            this.handleClose()
            this.$emit('getList')
          }
        })
      }
    },

  }

};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>














  #map-container{
    width:100%;
    height:400px;
  }

</style>

